import { render, staticRenderFns } from "./PeriodStatusTag.vue?vue&type=template&id=6f3af926&scoped=true"
import script from "./PeriodStatusTag.vue?vue&type=script&lang=js"
export * from "./PeriodStatusTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3af926",
  null
  
)

export default component.exports